import React from "react";
import { ManagerPrincipalModalProps } from "./ManagerPrincipalModal.types";
import { PrincipalOverview } from "../../../common/principals/PrincipalOverview";
import { VeriModal } from "../../../modals/VeriModal";

export const ManagerPrincipalModal: React.FC<ManagerPrincipalModalProps> = ({
  principalId,
  ...rest
}) => {
  return (
    <VeriModal {...rest}>
      <PrincipalOverview principalId={principalId} key={principalId} />
    </VeriModal>
  );
};
